import { buildASTSchema, graphql, type DocumentNode } from 'graphql';
import { http, HttpResponse, graphql as mswGraphql, passthrough } from 'msw';
import { setupWorker } from 'msw/browser';
import config from 'walden-fast/config/environment';
import { getHandlers, postHandlers } from './msw-for-fast';
import { mutationMethods, queryMethods } from './msw-for-box';

export default {
  start: async (schema: DocumentNode) => {
    const worker = setupWorker(
      http.get('/assets/*', passthrough),
      http.get('/favicon*', passthrough),
      http.post('https://*.mapbox.com/*', passthrough),
      http.get('https://*.mapbox.com/*', passthrough),
      http.get('https://fonts.gstatic.com/*', passthrough),
      http.get('https://picsum.photos/*', passthrough),
      http.get('https://*.clarity.ms/*', passthrough),
      http.post('https://*.clarity.ms/*', passthrough),
      http.post(
        'https://*.ingest.us.sentry.io/api/4508850664964096/envelope/*',
        passthrough,
      ),
      http.get(
        'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/*',
        passthrough,
      ),
      http.get(`${config.msal.authority}/*`, passthrough),
      http.post(`${config.msal.authority}/*`, passthrough),
      http.post(
        'https://logic-walden-trace-001.azurewebsites.net/api/*',
        passthrough,
      ),
      http.post(
        'https://logic-walden-chat-001.azurewebsites.net/api/*',
        passthrough,
      ),
      http.post(`${config.chatApi.URL}/*`, passthrough),
    );

    if (
      config.msw.endpointsToMock === 'fast' ||
      config.msw.endpointsToMock === 'all' ||
      config.msw.endpointsToMock === 'unexisting'
    ) {
      worker.use(
        // Rest - Walden Fast API
        ...getHandlers,
        ...postHandlers,
      );
    }

    // GraphQL - Walden Box API
    // All -> mock / Unexisting -> passthrough / None -> passthrough
    if (config.msw.endpointsToMock === 'all') {
      const graphqlOperation = createGraphqlOperationHandler(schema);
      worker.use(graphqlOperation);
    } else {
      worker.use(http.post(config.apollo.apiURL, passthrough));
    }

    await worker.start({
      onUnhandledRequest: 'warn',
    });

    return worker;
  },
  graphql: mswGraphql,
};

// blatantly stole this from @bagaar/ember-graphql-mocking , but I couldn't import it, maybe this is only possible in test code?
function createGraphqlOperationHandler(schemaDocument: DocumentNode) {
  const schema = buildASTSchema(schemaDocument);
  const graphqlOperation = mswGraphql.operation(
    async ({ query, variables }) => {
      const { data, errors } = await graphql({
        rootValue: {
          ...queryMethods,
          ...mutationMethods,
        },
        schema,
        source: query,
        variableValues: variables,
      });

      // @ts-expect-error: dont think this is something we can / should type
      return HttpResponse.json({ errors, data });
    },
  );

  return graphqlOperation;
}
